(ns iris.censors.events
  (:require
   [re-frame.core :as re-frame]
   [ajax.core :as ajax]
   [cljs.core.async :refer [go go-loop <! chan take!]]
   [iris.db :as db]
   [iris.events :as events]
   [iris.error.events :as error-events]
   [iris.indexeddb :as idb]
   [iris.hench :as hench]
   [iris.utils :as utils]
   [clojure.string :as string]
   [iris.globals :as globals]
   [iris.worker-pool :as worker-pool]
   ))


;; TODO: http complete is repeated in each section
(re-frame/reg-event-db
 ::http-complete
 (fn [db [_ data]]
   (assoc db :loading false)))


(re-frame/reg-event-db
 ::reset-form-data
 (fn [db [_ data]]
   (let [defaults {:ts (.now js/Date)
                   :scopes_input ".ALL"
                   :target_level 0
                   :kind ""
                   :pattern ""
                   :target-title true
                   :target-body true
                   :target-signed true
                   :target_fields ["title" "body" "signed"]
                   :case_sensitive false
                   :preserve_case false
                   :ignore_inserts false
                   :similar_chars false
                   :autosub true
                   :sub ""
                   :disable_in ""
                   :disable-in-number nil
                   :disable-in-unit "d"
                   :notes ""
                   :submitted false}
         form-data (if (some? data) (merge defaults data) defaults)]
     (assoc-in db [:censors :form-data] form-data))))


(re-frame/reg-event-db
 ::set-censor-prop
 (fn [db [_ prop val]]
   (assoc-in db [:censors :form-data prop] val)))


(re-frame/reg-event-db
 ::set-censor-error-prop
 (fn [db [_ prop val]]
   (assoc-in db [:censors :form-errors prop] val)))


(re-frame/reg-event-db
 ::reset-censor-errors
 (fn [db [_]]
   (assoc-in db [:censors :form-errors] {:scopes_input false
                                         :target_level false
                                         :kind false
                                         :pattern false
                                         :target_fields false})))


(re-frame/reg-event-db
 ::reset-censor-message
 (fn [db [_]]
  ;;  (assoc-in db [:censors :message] nil)
   (assoc-in db [:message] nil)))


(re-frame/reg-event-db
 ::set-censor-rule-data
 (fn [db [_ data]]
   (-> db
       (assoc-in [:censors :form-data] (get-in data [:result :data]))
;; TODO: check on this, took it out because it was resetting message to nil
       ;;  (assoc-in
      ;;   ;; [:censors :message]
      ;;   [:message]
      ;;   (get-in data [:error :message]))
       )))


(re-frame/reg-event-db
 ::http-get-censor-rule-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (cond (get-in data [:result :data])
        ;;  turned off raidizing eids through worker and firebase
        ;;  (when-let [result-data (get-in data [:result :data])]
        ;;    (if-let [eids (not-empty (hench/get-distinct-scopes (conj [] result-data)))]
        ;;      (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})
        ;;             (fn [raidized-eids]
        ;;               (let [scopes-input-raidized (hench/raidize-scopes-display
        ;;                                            (:scopes result-data)
        ;;                                            (:scopes_input result-data)
        ;;                                            {:eids-raids (:result raidized-eids)})
        ;;                     new-data (assoc-in data [:result :data :scopes-input-raidized] scopes-input-raidized)]
        ;;                 (re-frame/dispatch [::set-censor-rule-data new-data]))))
        ;;      ;;  set data for non-raidazable eids
        ;;      (re-frame/dispatch [::set-censor-rule-data data])))
         (re-frame/dispatch [::set-censor-rule-data data])
         (get-in data [:error :message])
         (re-frame/dispatch [::error-events/set-error {:title "Error: Censoring rule not found!"
                                                       :message (get-in data [:error :message])
                                                       :a-href "/censoring"
                                                       :a-txt "Return to Censoring"}]))
   db))


(re-frame/reg-event-db
 ::http-get-censor-rule-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;      (assoc-in
   ;;       ;; [:censors :message]
   ;;       [:message]
   ;;       "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-get-censor-rule
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Get"
              :params {:options {:debug false}
                       :data id}}
             [::http-get-censor-rule-success]
             [::http-get-censor-rule-failure])))


(re-frame/reg-event-db
 ::set-censor-list-data
 (fn [db [_ data]]
   (let [result-data (get-in data [:result :data])
         result-meta (get-in data [:result :meta])]
     (-> db
         (assoc-in [:censors :data] result-data)
         (assoc-in [:censors :meta] result-meta)))))


(re-frame/reg-event-db
 ::http-get-censor-list-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]

   (re-frame/dispatch [::set-censor-list-data data])
   (re-frame/dispatch [::http-complete])

  ;;  turned off raidizing eids through worker and firebase
  ;;  (when-let [result-data (get-in data [:result :data])]
  ;;    (when-let [eids (not-empty (hench/get-distinct-scopes result-data))]
  ;;      (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})
  ;;             (fn [raidized-result-data]
  ;;                    ;; (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])
  ;;               (loop [result-data result-data
  ;;                      raidized-data []]
  ;;                 (let [d (first result-data)
  ;;                       rest-data (rest result-data)
  ;;                       new-raidized-data (conj raidized-data
  ;;                                               (conj d [:scopes-display-raidized
  ;;                                                        (hench/raidize-scopes-display
  ;;                                                         (:scopes d)
  ;;                                                         (string/replace (:scopes_display d) "censors" "censoring")
  ;;                                                         {:eids-raids (:result raidized-result-data)})]))]
  ;;                   (if (not-empty rest-data)
  ;;                     (recur rest-data new-raidized-data)
  ;;                     (let [new-data (assoc-in data [:result :data] new-raidized-data)]
  ;;                       (re-frame/dispatch [::set-censor-list-data new-data])))))))))
   db))


(re-frame/reg-event-db
 ::http-get-censor-list-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;      (assoc-in
   ;;       ;; [:censors :message]
   ;;       [:message]
   ;;       "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-get-censor-list
 (fn [e [_ query-params]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.List"
              :params {:options {:debug false}
                       :data (merge {:bookmark ""
                                    ;;  :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                                     :limit (if-not (zero? (int (:limit query-params))) (int (:limit query-params)) 50)
                                     :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)}
                                    (when-let [order (:order query-params)]
                                      {:order order})
                                    (when-let [scope (:scope query-params)]
                                      {:scope scope}))}}
             [::http-get-censor-list-success]
             [::http-get-censor-list-failure])))


(re-frame/reg-event-fx
 ::http-search-censor-list
 (fn [e [_ query-params]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Search"
              :params {:options {:debug false}
                       :data (merge {:q (:q query-params)
                                    ;;  :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                                     :limit (if-not (zero? (int (:limit query-params))) (int (:limit query-params)) 50)
                                     :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)})}}
             [::http-get-censor-list-success]
             [::http-get-censor-list-failure])))


(re-frame/reg-event-db
 ::http-create-censor-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::events/navigate :censors])
   (-> db
       (assoc-in [:censors :form-data :submitted] false)
      ;;  (assoc-in
      ;;   ;; [:censors :message]
      ;;   [:message]
      ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
       )
   ))


(re-frame/reg-event-db
 ::http-create-censor-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;      (assoc-in [:censors :form-data :submitted] false)
   ;;      (assoc-in
   ;;       ;; [:censors :message]
   ;;       [:message]
   ;;       "API connection failure!"))
   db))


(re-frame/reg-event-db
 ::set-censor-submitted
 (fn [db [_ data]]
   (assoc-in db [:censors :form-data :submitted] data)))


(re-frame/reg-event-fx
 ::censor-create
 (fn [e [_ data]]
   (re-frame/dispatch [::reset-form-data])
   (re-frame/dispatch [::set-censor-submitted true])
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Create"
              :params {:options {:debug false}
                       :data data}}
             [::http-create-censor-success]
             [::http-create-censor-failure])))


(re-frame/reg-event-db
 ::http-update-censor-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::events/navigate :censors])
   (-> db
       (assoc-in [:censors :form-data :submitted] false)
      ;;  (assoc-in
      ;;   ;; [:censors :message]
      ;;   [:message]
      ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
       )))


(re-frame/reg-event-db
 ::http-update-censor-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   (-> db
       (assoc-in [:censors :form-data :submitted] false)
      ;;  (assoc-in
      ;;   ;; [:censors :message]
      ;;   [:message]
      ;;   "API connection failure!")
       )))


(re-frame/reg-event-fx
 ::censor-update
 (fn [e [_ data]]
  ;;  (re-frame/dispatch [::reset-form-data]) ;; is it needed for update?
   (re-frame/dispatch [::set-censor-submitted true]) ;; is it needed for update?
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Update"
              :params {:options {:debug false}
                       :data data}}
             [::http-update-censor-success]
             [::http-update-censor-failure])))


;; enable

(re-frame/reg-event-db
 ::http-enable-censor-rule-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;   (assoc-in
   ;;   ;;  [:censors :message]
   ;;    [:message]
   ;;    (or (get-in data [:result :message]) (get-in data [:error :message]))))
   db))


(re-frame/reg-event-db
 ::http-enable-censor-rule-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;      (assoc-in
   ;;       ;; [:censors :message]
   ;;       [:message]
   ;;       "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-enable-censor-rule
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Enable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-enable-censor-rule-success]
             [::http-enable-censor-rule-failure])))


(re-frame/reg-event-fx
 ::http-disable-censor-rule
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Disable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-enable-censor-rule-success]
             [::http-enable-censor-rule-failure])))


;; edit-enable

(re-frame/reg-event-db
 ::http-edit-enable-censor-rule-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (-> db
       (assoc-in [:censors :form-data :enabled] (get-in data [:result :data :enabled]))
       (assoc-in [:censors :form-data :disable_on_formatted] (get-in data [:result :data :disable_on_formatted]))
       (assoc-in [:censors :form-data :iso_disable_on] (get-in data [:result :data :iso_disable_on]))
       (assoc-in [:censors :form-data :disable_in] (get-in data [:result :data :disable_in]))
      ;;  (assoc-in
      ;;   ;; [:censors :message]
      ;;   [:message]
      ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
       )))


(re-frame/reg-event-db
 ::http-edit-enable-censor-rule-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:censors :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-edit-enable-censor-rule
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Enable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-edit-enable-censor-rule-success]
             [::http-edit-enable-censor-rule-failure])))


(re-frame/reg-event-fx
 ::http-edit-disable-censor-rule
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Disable"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-edit-enable-censor-rule-success]
             [::http-edit-enable-censor-rule-failure])))


(re-frame/reg-event-db
 ::http-censor-delete-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
   (when-let [message (get-in data [:result :message])]
     (let [ruid (last (re-find #"deleted:\s(.*)$" message))
           db-censors-data (get-in db [:censors :data])
           n-db-censors-data (filter #(not= ruid (:ruid %)) db-censors-data)]
       (assoc-in db [:censors :data] n-db-censors-data)
       (-> db
           (assoc-in [:censors :data] n-db-censors-data)
          ;;  (assoc-in
          ;;   ;; [:censors :message]
          ;;   [:message]
          ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
           )))))


(re-frame/reg-event-db
 ::http-censor-delete-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;      (assoc-in
   ;;       ;; [:censors :message]
   ;;       [:message]
   ;;       "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::censor-delete
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
              :id 0
              :method "Censor.Delete"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-censor-delete-success]
             [::http-censor-delete-failure])))